import React, { memo } from "react";
import PropTypes from "prop-types";

function ManageAdminsModal({
    onClose,
    newAdminEmail,
    setNewAdminEmail,
    onAddAdmin,
    adminsList,
    onRemoveAdmin,
    saneEmail
}) {
    return (
        <div className="aus-modal-overlay">
            <div className="aus-modal">
                <button className="aus-modal-close" onClick={onClose}>
                    &times;
                </button>
                <h3>Manage Admins</h3>

                <div className="aus-add-section">
                    <input
                        type="email"
                        className="aus-add-input"
                        placeholder="Enter admin email"
                        value={newAdminEmail}
                        onChange={(e) => setNewAdminEmail(e.target.value)}
                    />
                    <button className="aus-add-btn" onClick={onAddAdmin}>
                        Add
                    </button>
                </div>

                <h4>Existing Admins</h4>
                <ul className="aus-admin-list">
                    {adminsList.map(adminKey => (
                        <li key={adminKey} className="aus-admin-item">
                            <span>{adminKey}</span>
                            <button
                                className="aus-remove-btn"
                                onClick={() => onRemoveAdmin(adminKey)}
                                disabled={adminKey === saneEmail}
                                title={adminKey === saneEmail ? "Cannot remove yourself" : ""}
                            >
                                Remove
                            </button>
                        </li>
                    ))}
                    {adminsList.length === 0 && (
                        <li className="aus-admin-item">No admins found other than you?</li>
                    )}
                </ul>
            </div>
        </div>
    );
}

ManageAdminsModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    newAdminEmail: PropTypes.string.isRequired,
    setNewAdminEmail: PropTypes.func.isRequired,
    onAddAdmin: PropTypes.func.isRequired,
    adminsList: PropTypes.arrayOf(PropTypes.string).isRequired,
    onRemoveAdmin: PropTypes.func.isRequired,
    saneEmail: PropTypes.string
};

export default memo(ManageAdminsModal);
